<template>
  <div class="d-none" />
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    onCartPage: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      items: (state) => state.cart.items,
      totalPrice: (state) => state.cart.total_price,
    }),
  },

  created() {
    const cartIcon = document.querySelector('.js-cart-drawer-toggle');

    if (cartIcon && !this.onCartPage) {
      cartIcon.addEventListener('click', () => {
        // eslint-disable-next-line no-undef
        datalayerViewCart({
          items: this.items,
          totalPrice: this.totalPrice,
        });
      });
    }
  },
}
</script>

<style>

</style>